import i18n from "i18next";
import ChainedBackend from "i18next-chained-backend";
import Backend from "i18next-http-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next/initReactI18next";
import { servicesOrchestratorValues } from "./config/services";
import en from "./locales/en.json";

const bundledResources = {
	en: { translation: en },
};

const LOCALIZATION_PROVIDER_BASE_URL = servicesOrchestratorValues.app.simpleLocalizeBaseUrl;
const projectToken = servicesOrchestratorValues.credentials.simpleLocalizeProjectToken;
const environment = servicesOrchestratorValues.credentials.simpleLocalizeEnvironment;

const loadPath = `${LOCALIZATION_PROVIDER_BASE_URL}/${projectToken}/${environment}/{{lng}}`;

i18n
	.use(ChainedBackend)
	.use(initReactI18next)
	.init({
		lng: "en",
		fallbackLng: "en",
		backend: {
			backends: [Backend, resourcesToBackend(bundledResources)],
			backendOptions: [
				{
					loadPath: loadPath,
				},
			],
		},
		saveMissing: false,
	});

export default i18n;
